/**
 * The timeline: one append-only stream per record, shared by all three kinds
 * so an incident's history and a change's history are the same shape and one
 * component renders both. Human actions, system actions and (later) agent,
 * GitHub and deployment actions all land here with an actor type, which is
 * what makes "84% detected by automation" a query rather than a guess.
 *
 * Append-only is enforced by grants in migration 0059 (the app role may
 * insert and select, never update or delete), not by convention.
 */

export const TIMELINE_EVENT_TYPES = [
  'CREATED', 'STATUS_CHANGED', 'SEVERITY_CHANGED', 'FIELD_CHANGED', 'NOTE',
  'IMPACT_ADDED', 'IMPACT_REMOVED', 'LINK_ADDED', 'LINK_REMOVED',
  // Cut 2: what the eyes saw. DIAGNOSTIC is a snapshot an operator asked for;
  // SIGNAL and SIGNAL_CLEARED are the sweep's own observations.
  'DIAGNOSTIC', 'SIGNAL', 'SIGNAL_CLEARED',
  // Cut 4: a public status update was published (or failed to be).
  'STATUS_PUBLISHED',
  // Cut 5: a notification went out (Slack), or failed to.
  'NOTIFIED',
  /** ADR-60 cut 7: a remote support command sent under this incident. */
  'SUPPORT_COMMAND',
  /** ADR-61 cut 1: a gate evaluated (with its evidence), an approval recorded, a governance-plane action. */
  'GATE_EVALUATED', 'APPROVAL_RECORDED', 'GOVERNANCE', 'EXECUTION', 'VALIDATION', 'RECONCILIATION',
] as const;
export type TimelineEventType = (typeof TIMELINE_EVENT_TYPES)[number];

export const ACTOR_TYPES = ['OPERATOR', 'SYSTEM', 'AGENT', 'AUTOMATION', 'GITHUB', 'DEPLOYMENT', 'STATUS'] as const;
export type ActorType = (typeof ACTOR_TYPES)[number];
